import React, { useEffect, useState } from 'react';
import { AdContentTO } from './use-adserveContent';
import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from '@mui/material/CardActionArea';

type Props = {
  data?: AdContentTO;
  isVisible?: boolean;
  zone?: string;
};

export function AdContent(props: Props) {
  const { data, isVisible, zone } = props;
  const [isViewed, setIsViewed] = useState(false);

  useEffect(() => {
    setIsViewed(isVisible ?? false); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.banner_id, zone]);

  useEffect(() => {
    if (isVisible) {
      setIsViewed(true);
    }
  }, [isVisible]);

  if (!data) return null;

  return (
    <>
      {data && (
        <CardActionArea
          data-campaign={data.metadata.adobe_tracking_tag}
          data-name={data.banner_id}
          data-placement={zone}
          data-type={'AdButler Banner'}
          href={data.redirect_url}
          style={{ margin: 'auto' }}
          target={data.target}
        >
          {data.body && (
            <Box
              dangerouslySetInnerHTML={{ __html: data.body }}
              data-testid="ad-body-content"
              sx={{
                '& *': {
                  maxWidth: '100%',
                },
                overflow: 'hidden',
                width: '100%',
              }}
            />
          )}
          <CardMedia
            alt={data.alt_text}
            component="img"
            image={data.image_url}
            style={{
              height: data?.height ?? 'auto',
              width: data?.width ?? '100%',
            }}
          />
          <CardMedia
            component="img"
            image={data.accupixel_url}
            style={{
              display: 'none',
              height: '1',
              width: '1',
            }}
          />

          {isViewed && (
            <CardMedia
              component="img"
              image={data.viewable_url}
              style={{
                display: 'none',
                height: '1',
                width: '1',
              }}
            />
          )}
          <CardMedia
            component="img"
            image={data.eligible_url}
            style={{
              display: 'none',
              height: '1',
              width: '1',
            }}
          />
        </CardActionArea>
      )}
    </>
  );
}
